import { mapState, mapMutations } from 'vuex'
import hostMap from '@/utils/wujie/hostMap'
import WujieVue from 'wujie-vue2'

export default {
  computed: {
    ...mapState('company', ['workbenchColor', 'companyId', 'companyName']),
    ...mapState('user', ['employeeId', 'employeeName', 'isSigner']),
    ...mapState('router', ['currentWorkbench']),
    ...mapState('system', ['isSideCollapse', 'consumerHotline']),

    isMicroApp() {
      return this.$route.meta.isMicro
    },

    wujieName() {
      return this.$route.meta.microName || 'performance'
    },

    queryPath() {
      return `/${this.$route.path.split('/').pop()}`
    },

    wujieUrl() {
      return hostMap(this.wujieName) + this.queryPath
    },

    wujieProps() {
      return {
        workbenchColor: this.workbenchColor,
        currentPlatform: this.currentWorkbench,
        isSideCollapse: this.isSideCollapse,
        breadcrumbList: this.$route?.meta?.breadcrumb || [],
        // 顶部导航栏高度（等于$header-height）
        headerHeight: 64,
        // 子应用通过父应用切换不同菜单页面
        jump: this.jump,
        employeeId: this.employeeId,
        employeeName: this.employeeName,
        companyId: this.companyId,
        companyName: this.companyName,
        consumerHotline: this.consumerHotline,
        isSigner: this.isSigner,
      }
    }
  },

  methods: {
    ...mapMutations('router', {
      clearCacheView: 'CLEAR_CACHE_VIEW'
    }),

    jump(option) {
      // this.clearCacheView()
      this.$router.push(option)
    },

    wujieBeforeLoad() {
      console.log('==app beforeLoad==', this.$route.query)
    },

    wujieAfterUnmount() {
      console.log('==app afterUnmount==', this.$route.query)
    },

    wujieAfterMount(appWindow) {
      console.log('==app afterMount==', this.$route.query)

      const newQueryUrl = this.$route.query?.[this.wujieName] || ''
      if (this.isMicroApp && newQueryUrl && newQueryUrl !== this.queryPath) {
        // console.log('this.$route.name=', this.$route.name, 'newQueryUrl=', newQueryUrl)
        this.$router.push({ name: this.$route.name, query: { [this.wujieName]: newQueryUrl } })
        WujieVue.bus.$emit('routerChange', { menuName: this.$route.name, path: newQueryUrl })
      }
    },

    wujieActivated(appWindow) {
      console.log('==app activated==', this.$route.query)

      WujieVue.bus.$emit('activated')

      const newQueryUrl = this.$route.query?.[this.wujieName] || ''
      if (this.isMicroApp && newQueryUrl && newQueryUrl !== this.queryPath) {
        // console.log('this.$route.name=', this.$route.name, 'newQueryUrl=', newQueryUrl)
        this.$router.push({ name: this.$route.name, query: { [this.wujieName]: newQueryUrl } })
        WujieVue.bus.$emit('routerChange', { menuName: this.$route.name, path: newQueryUrl })
      }
    },

    wujieDeactivated(appWindow) {
      console.log('==app deactivated==', this.$route.query)

      WujieVue.bus.$emit('deactivated')
    }
  }
}

